/**
 * Mapeamento de origem para labels descritivos.
 */
export const originLabels: Record<string, string> = {
  'capturaweb': 'CapturaWeb (CW)',
  'push': 'Push',
  'autorequest': 'Autorequest',
  'codilo-dt-projuris': 'Codilo DT - Projuris',
  'codilo-dt-saj': 'Codilo DT - Saj',
  'codilo-dt-peticiona': 'Codilo DT - Peticiona',
  'codilo-dt-dev': 'Codilo DT - Dev',
  'datateam-prod': 'Datateam Prod (DESATIVADO)',
  'datateam-saj': 'Datateam Saj (DESATIVADO)',
  'datateam-projuris': 'Datateam Projuris (DESATIVADO)',
};

